"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaConstructionSubmitResponseToJSON = exports.RosettaConstructionSubmitResponseFromJSONTyped = exports.RosettaConstructionSubmitResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaConstructionSubmitResponseFromJSON(json) {
    return RosettaConstructionSubmitResponseFromJSONTyped(json, false);
}
exports.RosettaConstructionSubmitResponseFromJSON = RosettaConstructionSubmitResponseFromJSON;
function RosettaConstructionSubmitResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transaction_identifier': _1.TransactionIdentifierFromJSON(json['transaction_identifier']),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : json['metadata'],
    };
}
exports.RosettaConstructionSubmitResponseFromJSONTyped = RosettaConstructionSubmitResponseFromJSONTyped;
function RosettaConstructionSubmitResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transaction_identifier': _1.TransactionIdentifierToJSON(value.transaction_identifier),
        'metadata': value.metadata,
    };
}
exports.RosettaConstructionSubmitResponseToJSON = RosettaConstructionSubmitResponseToJSON;
//# sourceMappingURL=RosettaConstructionSubmitResponse.js.map